import React, { Component } from 'react';
import DateTime from 'react-datetime';

import './../../../node_modules/react-datetime/css/react-datetime.css';

class OpinionForm extends Component
{
    constructor(props)
    {
        super(props);

        this.onChange = props.onChange;
        
        this.handeInput = this.handeInput.bind(this);
        this.handleDate = this.handleDate.bind(this);

        this.DateTime = React.createRef();
    }

    handeInput(event)
    {
        let value = event.target.type === 'checkbox' ? (event.target.checked === true ? 1 : 0) : event.target.value;
        let evt = {
            "target" : {
                "name" : event.target.name,
                "value" : value
            } 
        }
        
        this.onChange(evt);
    }

    handleDate(ref, name, date)
    {
        ref.current.querySelector('.text-danger').style.display = "none";
        ref.current.querySelector('.rdt .form-control').classList.remove("invalid")
        if(date._isAMomentObject == null)
        {
            ref.current.querySelector('.text-danger').style.display = "initial";
            ref.current.querySelector('.rdt .form-control').classList.add("invalid");
            let evt = {
                "target" : {
                    "name" : name,
                    "value" : null
                } 
            }
            this.onChange(evt);
            return;
        }
        else
        {
            let evt = {
                "target" : {
                    "name" : name,
                    "value" : date.unix()
                } 
            }
            this.onChange(evt);
        }
    }

    render()
    {
        return (
            <div className="fade modal show" id="addOpinionModal" tabIndex="-1" role="dialog" aria-labelledby="addOpinionModalLabel" aria-modal="true">
            <div className="modal-dialog modal-full-height modal-right" role="document">
                <div className="modal-content rounded-0 p-3">
                    <button type="button" className="close closeSideModal" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                    <div className="modal-header">
                        <h4 className="modal-title" id="addOpinionModalLabel">Ajouter un avis</h4>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col">
                                <div className="form-group">
                                    <label className="h5 font-weight-bold"> 
                                        Source
                                    </label>
                                    <select className="form-control" name="source" value={ this.props.opinion.source } onChange={ this.handeInput }>
                                        <option disabled selected value=""> -- Choisissez une source -- </option>
                                        <option value="GarageScore">GarageScore</option>
                                        <option value="Google">Google</option>
                                        <option value="Facebook">Facebook</option>
                                        <option value="VOC">VOC</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Concession
                                    </label>
                                    <input type="text" maxLength="100" className="form-control" name="dealership" value={ this.props.opinion.dealership } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 100 caractères.
                                    </small>
                                </div>
                                <div className="form-group">
                                    <label className="h5 font-weight-bold"> 
                                        Service
                                    </label>
                                    <select className="form-control" name="service" value={ this.props.opinion.service } onChange={ this.handeInput }>
                                        <option disabled selected value=""> -- Choisissez un service -- </option>
                                        <option value="VN DACIA">VN DACIA</option>
                                        <option value="VN RENAULT">VN RENAULT</option>
                                        <option value="VO">VO</option>
                                        <option value="AT">AT</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Note
                                    </label>
                                    <input type="number" min="0" max="10" className="form-control" name="note" value={ this.props.opinion.note } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir un nombre entre 0 et 10.
                                    </small>
                                </div>

                                <div className="form-group" ref={ this.DateTime }>
                                    <label className="h5 font-weight-bold">
                                        Date
                                    </label>
                                    <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTime, "date", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.opinion.date != null ? this.props.opinion.date*1000 : null } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir une date valide
                                    </small>
                                </div>

                                <div className="form-group">
                                    <label className="h5 font-weight-bold">
                                        Commentaire
                                    </label>
                                    <textarea type="text" maxLength="400" className="form-control" name="comment" value={ this.props.opinion.comment } onChange={ this.handeInput } />
                                    <small className="text-danger form-text">
                                        Ce champ doit contenir moins de 400 caractères.
                                    </small>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className='btn btn-primary float-right' onClick={()=> this.props.onSubmit()}>
                            <li className='fas fa-save'> </li> Enregistrer
                        </button>
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OpinionForm;


// WEBPACK FOOTER //
// ./src/Components/Opinion/OpinionForm.js